import React, { useEffect, useState, useCallback } from 'react';
import '../../styles/toast.css';

interface ToastItem {
  id: number;
  message: string;
  type: 'success' | 'error' | 'info';
}

/** 全局 Toast 队列 */
let toastListeners: Array<(toast: ToastItem) => void> = [];
let toastIdCounter = 0;

/** 全局调用入口 */
export const showToast = (message: string, type: 'success' | 'error' | 'info' = 'success'): void => {
  const item: ToastItem = { id: ++toastIdCounter, message, type };
  toastListeners.forEach((fn) => fn(item));
};

/** Toast 图标 */
const ToastIcon: React.FC<{ type: ToastItem['type'] }> = ({ type }) => {
  if (type === 'success') {
    return (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#10b981" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 6L9 17l-5-5" />
      </svg>
    );
  }
  if (type === 'error') {
    return (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <line x1="15" y1="9" x2="9" y2="15" />
        <line x1="9" y1="9" x2="15" y2="15" />
      </svg>
    );
  }
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="16" x2="12" y2="12" />
      <line x1="12" y1="8" x2="12.01" y2="8" />
    </svg>
  );
};

const TOAST_DURATION = 2500;

const ToastContainer: React.FC = () => {
  const [toasts, setToasts] = useState<ToastItem[]>([]);

  const addToast = useCallback((item: ToastItem) => {
    setToasts((prev) => [...prev, item]);
  }, []);

  // 注册监听器
  useEffect(() => {
    toastListeners.push(addToast);
    return () => {
      toastListeners = toastListeners.filter((fn) => fn !== addToast);
    };
  }, [addToast]);

  // 自动移除
  useEffect(() => {
    if (toasts.length === 0) return;

    const timer = setTimeout(() => {
      setToasts((prev) => prev.slice(1));
    }, TOAST_DURATION);

    return () => clearTimeout(timer);
  }, [toasts]);

  if (toasts.length === 0) return null;

  return (
    <div className="ai-svg-toast-container">
      {toasts.map((t) => (
        <div key={t.id} className={`ai-svg-toast ai-svg-toast--${t.type}`}>
          <ToastIcon type={t.type} />
          <span className="ai-svg-toast__text">{t.message}</span>
        </div>
      ))}
    </div>
  );
};

export default ToastContainer;